import Vue from 'vue'
import Router from 'vue-router'


import menu from "../Page/menu";

// const menu = () => import("@/Page/menu")
const ComparativeAnalysis = () => import("@/Page/ComparativeAnalysis")
const AnalysisGraph = () => import(/* webpackChunkName: 'pump' */ "@/Page/AnalysisGraph");
const SubclassFaultDiagnosis = () => import(/* webpackChunkName: 'pump' */"@/Page/RotorFaultDiagnosis")
const OrbitOfShaftCenter = () => import(/* webpackChunkName: 'pump' */"@/Page/OrbitOfShaftCenter")
const AlarmQueryGraph = () => import(/* webpackChunkName: 'pump' */"@/Page/AlarmQueryGraph")
const ComprehensiveAnalysis = () => import(/* webpackChunkName: 'pump' */"@/Page/ComprehensiveAnalysis")
const ChangeVisualization = () => import(/* webpackChunkName: 'pump' */"@/Page/ChangeVisualization")
const OtherParametersTrendGraph = () => import(/* webpackChunkName: 'pump' */"@/Page/OtherParametersTrendGraph")
const RunSwordGraph = () => import(/* webpackChunkName: 'pump' */"@/Page/RunSwordGraph")
const RunStatusGraph = () => import(/* webpackChunkName: 'pump' */"@/Page/RunStatusGraph")
const VibrationMonitor = () => import(/* webpackChunkName: 'pump' */"@/Page/VibrationMonitor")
const UnitOverviewMap = () => import(/* webpackChunkName: 'pump' */"@/Page/UnitOverviewMap")
const MultiParametersTrendGraph = () => import(/* webpackChunkName: 'pump' */"@/Page/MultiParametersTrendGraph")
const SingleMultiBarValueChart = () => import(/* webpackChunkName: 'pump' */"@/Page/SingleMultiBarValueChart")
const StartstopGraph = () => import(/* webpackChunkName: 'pump' */"@/Page/StartstopGraph")
const TrendAnalysis = () => import(/* webpackChunkName: 'pump' */"@/Page/TrendAnalysis")
const PumpImpactDiagnosis = () => import(/* webpackChunkName: 'pump' */"@/Page/PumpImpactDiagnosis")
const CepstrumGraph = () => import(/* webpackChunkName: 'pump' */"@/Page/CepstrumGraph")
const WaveformSpectraComparativeAnalysis = () => import(/* webpackChunkName: 'pump' */"@/Page/WaveformSpectraComparativeAnalysis")
const SpectraWaterfall = () => import(/* webpackChunkName: 'pump' */"@/Page/SpectraWaterfall")

//扶梯
const EscalatorAlarmQueryGraph = () => import(/* webpackChunkName: 'alarm' */ "../Page/EscalatorGraph/AlarmQueryGraph")
const EscalatorSubclassFaultDiagnosis = () => import(/* webpackChunkName: 'alarm' */ "@/Page/EscalatorGraph/RotorFaultDiagnosis")
const EscalatorOtherParametersTrendGraph = () => import(/* webpackChunkName: 'alarm' */ "@/Page/EscalatorGraph/OtherParametersTrendGraph")
const EscalatorSingleMultiBarValueChart = () => import(/* webpackChunkName: 'alarm' */ "@/Page/EscalatorGraph/SingleMultiBarValueChart")
const EscalatorTrendAnalysis = () => import(/* webpackChunkName: 'alarm' */ "@/Page/EscalatorGraph/TrendAnalysis")
const EscalatorPumpImpactDiagnosis = () => import(/* webpackChunkName: 'alarm' */ "@/Page/EscalatorGraph/PumpImpactDiagnosis")
const EscalatorCepstrumGraph = () => import(/* webpackChunkName: 'alarm' */ "@/Page/EscalatorGraph/CepstrumGraph")


//以下是在线报告报表

const OneBarGraph = () => import("@/Page/DieselMonitorSystem/OneBarGraph")

//以下是旋转机械

const RotatingSingleMultaBarGraph = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingSingleMultaBarGraph")
const OrbitOfShaftCenter1 = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/OrbitOfShaftCenter1")
const OtherParametersTrendGraph2 = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/OtherParametersTrendGraph2")
const VibrationHistoricalComparison = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/VibrationHistoricalComparison")
const ThreeDimensionalHolography = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/ThreeDimensionalHolography")
const TwoDimensionalHolography = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/TwoDimensionalHolography")
const RotatingOverviewGrap = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingOverviewGrap")
const RotatingRunStatusGraph = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingRunStatusGraph")
const RotatingVibrationMonitor = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingVibrationMonitor")
const AxisPosition = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/AxisPosition")
const WholeSpectrumGraph = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/WholeSpectrumGraph")
const StartStopGraph = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/StartStopGraph")
const RotatingComprehensiveAnalysis = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingComprehensiveAnalysis")
const AlarmQueryGraph2 = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/AlarmQueryGraph2")
const DynamicBalancing = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/DynamicBalancing")
const TemperatureiDstributionField = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/TemperatureiDstributionField")
const ParameterComparisonQuery = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/ParameterComparisonQuery")
const RotatingImpactDiagnosis = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/ImpactDiagnosis")
const RotatingCepstrumGraph = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingCepstrumGraph")
const RotatingHistoryTrendGraph = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingHistoryTrendGraph")
const RotatingSpectraWaterfall = () => import(/* webpackChunkName: 'rotate' */ "@/Page/RotatingMachineryGraph/RotatingSpectraWaterfall")

//以下是柴油机和往复机，增加包请在上面加
//柴油机
import OverviewGraph from "../Page/DieselMonitorSystem/OverviewGraph";
// const OverviewGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/OverviewGraph")
const DieselMonitorRunStatus = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/DieselMonitorRunStatus")
const HistoricalComparisonGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/HistoricalComparisonGraph")
const SingleValueStickGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/SingleValueStickGraph")
const DynamicPressureMonitorGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/DynamicPressureMonitorGraph")
const EventQueryGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/EventQueryGraph")
const VibrationMonitorGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/VibrationMonitorGraph")
const InstantaneousSpeed = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/InstantaneousSpeed")
const TorsionalVibration = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/TorsionalVibration")
const MultiparameterAnalysis = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/MultiparameterAnalysis")
const ComprehensiveAnalysisGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/ComprehensiveAnalysisGraph")
const IndicatorGraph = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/IndicatorGraph")
const ImpactDiagnosis = () => import(/* webpackChunkName: 'Diesel' */"@/Page/DieselMonitorSystem/ImpactDiagnosis")
const OtherParametersTrend = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/OtherParametersTrend")
const AlarmQuery = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/AlarmQuery")
const OnAndOffStateAnalysis = () => import(/* webpackChunkName: 'Diesel' */ "@/Page/DieselMonitorSystem/OnAndOffStateAnalysis")
const StartAndStopTimeQuery = () => import(/* webpackChunkName: 'Diesel' */"@/Page/DieselMonitorSystem/StartAndStopTimeQuery")

//往复机

const OneBarGraph1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/OneBarGraph1")
const OverviewGraph1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/OverviewGraph1")
const ReciprocatAlarmQuery = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/ReciprocatAlarmQuery")
const RunStatusGraph1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/RunStatusGraph1")
const HistoricalComparisonGraph1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/HistoricalComparisonGraph1")
const SingleValueStickGraph1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/SingleValueStickGraph1")
const ReciprocatVibrationMonitor = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/ReciprocatVibrationMonitor")
const MultiparameterAnalysis1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/MultiparameterAnalysis1")
const ReciprocatComprehensiveAnalysis = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis")
const OtherParametersTrend1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/OtherParametersTrend1")
const IndicatorGraph1 = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/IndicatorGraph1")
const ReciprocatImpactDiagnosis = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/ReciprocatImpactDiagnosis")
const PistonRodSettlement = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/PistonRodSettlement")
const PistonRodTrackGraph = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/PistonRodTrackGraph")
const StressMonitoring = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/StressMonitoring")
const ReciprocatSpectraWaterfall = () => import(/* webpackChunkName: 'Reciprocat' */ "@/Page/ReciprocatMachineryGraph/ReciprocatSpectraWaterfall")

// 离线

const OLUnitOverviewMap = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLUnitOverviewMap")
const OLEnvelopeAnalysis = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLEnvelopeAnalysis")
const OLVibrationTrend = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLVibrationTrend")
const OLRetardedVariablesTrend = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLRetardedVariablesTrend")
const OLAlarmQueryAnalysis = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLAlarmQueryAnalysis")
const OLComparativeAnalysis = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLComparativeAnalysis")
const OLComparisonAnalysis = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLComparisonAnalysis")
const OLOrbitOfShaftCenter = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLOrbitOfShaftCenter")
const OLManualEntry = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLManualEntry")
const OLWallThicknessTrend = () => import(/* webpackChunkName: 'Offline' */ "@/Page/Offline/OLWallThicknessTrend")

//无线机泵

const WirelessPumpAlarmQueryGraph = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpAlarmQueryGraph")
const WirelessPumpUnitOverviewMap = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpUnitOverviewMap")
const WirelessPumpTrendAnalysis = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpTrendAnalysis")
const WirelessPumpImpactDiagnosis = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpImpactDiagnosis")
const WirelessPumpOtherParametersTrendGraph = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph")
const WirelessWaveformSpectraComparativeAnalysis = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WaveformSpectraComparativeAnalysis")
const WirelessPumpEdgeComputingGraph = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpEdgeComputingGraph")
const WirelessPumpCepstrumGraph = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpCepstrumGraph")
const WirelessPumpSpectraWaterfall = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessPumpGraph/WirelessPumpSpectraWaterfall")
//无线ToC

const ToCVibrationMonitor = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessToCMachineryGraph/ToCVibrationMonitor")
const ToCAlarmQueryGraph = () => import(/* webpackChunkName: 'Wireless' */ "@/Page/WirelessToCMachineryGraph/ToCAlarmQueryGraph")

//燃气轮机

const GasSingleMultaBarGraph = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/GasSingleMultaBarGraph")
const GasOrbitOfShaftCenter1 = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/OrbitOfShaftCenter1")
const GasOtherParametersTrendGraph2 = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/OtherParametersTrendGraph2")
const GasVibrationHistoricalComparison = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/VibrationHistoricalComparison")
const GasThreeDimensionalHolography = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/ThreeDimensionalHolography")
const GasTwoDimensionalHolography = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/TwoDimensionalHolography")
const GasOverviewGrap = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/GasOverviewGrap")
const GasRunStatusGraph = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/GasRunStatusGraph")
const GasVibrationMonitor = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/GasVibrationMonitor")
const GasAxisPosition = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/AxisPosition")
const GasWholeSpectrumGraph = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/WholeSpectrumGraph")
const GasStartStopGraph = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/StartStopGraph")
const GasComprehensiveAnalysis = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/GasComprehensiveAnalysis")
const GasAlarmQueryGraph2 = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/AlarmQueryGraph2")
const GasDynamicBalancing = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/DynamicBalancing")
const TemperatureiDstributionField1 = () => import(/* webpackChunkName: 'Gas' */  "@/Page/gasTurbineGraph/TemperatureiDstributionField1")

//加热炉

const HeatingFurnaceUnitOverviewMap = () => import(/* webpackChunkName: 'Heating' */   "@/Page/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap")
const HeatingFurnaceOtherParametersTrendGraph = () => import(/* webpackChunkName: 'Heating' */  "@/Page/HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph")






//注意在柴油机和往复机上面加包
Vue.use(Router)
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export default new Router({
  mode: 'hash',
  //如果IP下包含文件夹
  base: process.env.NODE_ENV == 'production' ? '/bs' : '',
  routes: [
    {
      path: '/',
      redirect:'/DieselMonitorSystem/OverviewGraph',
      name: 'menu',
      component: menu,
      meta: {
        keepAlive: false
      },
      children: [
        //扶梯
        {
          path: '/EscalatorSingleMultiBarValueChart',
          name: 'EscalatorSingleMultiBarValueChart',
          component: EscalatorSingleMultiBarValueChart,
          meta: {
            title: config.menu.EscalatorGraph.data._7name,
            keepAlive: false
          },

        },
        {
          path:'/EscalatorPumpImpactDiagnosis',
          name:'EscalatorPumpImpactDiagnosis',
          component:EscalatorPumpImpactDiagnosis,
          meta: {
            title: config.menu.EscalatorGraph.data._4name,
            keepAlive: false
          },
        },
        {
          path: '/EscalatorRotorFaultDiagnosis',
          name: 'EscalatorRotorFaultDiagnosis',
          component: EscalatorSubclassFaultDiagnosis,
          meta: {
            title: config.menu.EscalatorGraph.data._5name,
            keepAlive: false
          },
        },
        {
          path: '/EscalatorAlarmQueryGraph',
          name: 'EscalatorAlarmQueryGraph',
          component: EscalatorAlarmQueryGraph,
          meta: {
            title: config.menu.EscalatorGraph.data._2name,
            keepAlive: false
          },

        },
        {
          path: '/EscalatorOtherParametersTrendGraph',
          name: 'EscalatorOtherParametersTrendGraph',
          component: EscalatorOtherParametersTrendGraph,
          meta: {
            title: config.menu.EscalatorGraph.data._8name,
            keepAlive: false
          },
        },
        {
          path: '/EscalatorTrendAnalysis',
          name: 'EscalatorTrendAnalysis',
          component: EscalatorTrendAnalysis,
          meta: {
            title: config.menu.EscalatorGraph.data._3name,
            keepAlive: false
          },
        },
        {
          path: '/EscalatorCepstrumGraph',
          name: 'EscalatorCepstrumGraph',
          component: EscalatorCepstrumGraph,
          meta: {
            title: config.menu.EscalatorGraph.data._6name,
            keepAlive: false
          },
        },
        //加热炉
        {
          path: '/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap',
          name: 'HeatingFurnaceUnitOverviewMap',
          component: HeatingFurnaceUnitOverviewMap,
          meta: {
            keepAlive: false,
            title: config.menu.HeatingFurnace.data._1name
          },
        },
        {
          path: '/HeatingFurnaceGraph/HeatingFurnaceOtherParametersTrendGraph',
          name: 'HeatingFurnaceOtherParametersTrendGraph',
          component: HeatingFurnaceOtherParametersTrendGraph,
          meta: {
            keepAlive: false,
            title: config.menu.HeatingFurnace.data._2name
          },
        },
        //机泵
        {
          path: '/StartstopGraph',          //启停车
          name: 'StartstopGraph',
          component: StartstopGraph,
          meta: {
            keepAlive: false
          },

        },
        {
          path: '/SingleMultiBarValueChart',
          name: 'SingleMultiBarValueChart',
          component: SingleMultiBarValueChart,
          meta: {
            title: config.menu.SpecialManualOfPump.data._7name,
            keepAlive: true
          },

        },
        {
          path: '/UnitOverviewMap',
          name: 'UnitOverviewMap',
          component: UnitOverviewMap,
          meta: {
            title: config.menu.SpecialManualOfPump.data._1name,
            keepAlive: true
          },

        },
        {
          path:'/PumpImpactDiagnosis',
          name:'PumpImpactDiagnosis',
          component:PumpImpactDiagnosis,
          meta: {
            title: config.menu.SpecialManualOfPump.data._4name,
            keepAlive: true
          },
        },
        {
          path: '/RotorFaultDiagnosis',
          name: 'RotorFaultDiagnosis',
          component: SubclassFaultDiagnosis,
          meta: {
            title: config.menu.SpecialManualOfPump.data._5name,
            keepAlive: true
          },
        },
        {
          path: '/OrbitOfShaftCenter',
          name: 'OrbitOfShaftCenter',
          component: OrbitOfShaftCenter,
          meta: {
            title: config.menu.SpecialManualOfPump.data._9name,
            keepAlive: false
          },

        },
        {
          path: '/AlarmQueryGraph',
          name: 'AlarmQueryGraph',
          component: AlarmQueryGraph,
          meta: {
            title: config.menu.SpecialManualOfPump.data._2name,
            keepAlive: true
          },

        },
        {
          path: '/AnalysisGraph',
          name: 'AnalysisGraph',
          component: AnalysisGraph,
          meta: {
            title: config.menu.SpecialManualOfPump.data._14name,
            keepAlive: true
          },

        },
        {
          path: '/ComprehensiveAnalysis',
          name: 'ComprehensiveAnalysis',
          component: ComprehensiveAnalysis,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/RunStatusGraph',
          name: 'RunStatusGraph',
          component: RunStatusGraph,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/ChangeVisualization',
          name: 'ChangeVisualization',
          component: ChangeVisualization,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/RunSwordGraph',
          name: 'RunSwordGraph',
          component: RunSwordGraph,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/MultiParametersTrendGraph',
          name: 'MultiParametersTrendGraph',
          component: MultiParametersTrendGraph,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/OtherParametersTrendGraph',
          name: 'OtherParametersTrendGraph',
          component: OtherParametersTrendGraph,
          meta: {
            title: config.menu.SpecialManualOfPump.data._8name,
            keepAlive: true
          },
        },
        {
          path: '/VibrationMonitor',
          name: 'VibrationMonitor',
          component: VibrationMonitor,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/TrendAnalysis',
          name: 'TrendAnalysis',
          component: TrendAnalysis,
          meta: {
            title: config.menu.SpecialManualOfPump.data._3name,
            keepAlive: true
          },
        },
        {
          path: '/CepstrumGraph',
          name: 'CepstrumGraph',
          component: CepstrumGraph,
          meta: {
            title: config.menu.SpecialManualOfPump.data._6name,
            keepAlive: true
          },
        },
        {
          path: '/WaveformSpectraComparativeAnalysis',
          name: 'WaveformSpectraComparativeAnalysis',
          component: WaveformSpectraComparativeAnalysis,
          meta: {
            title: config.menu.SpecialManualOfPump.data._10name,
            keepAlive: true
          }
        },
        {
          path: '/SpectraWaterfall',
          name: 'SpectraWaterfall',
          component: SpectraWaterfall,
          meta: {
            title: config.menu.SpecialManualOfPump.data._11name,
            keepAlive: true
          }
        },

        //以下是旋转机械
        {
          path:'/RotatingMachineryGraph/AlarmQueryGraph2',
          name:'AlarmQueryGraph2',
          component: AlarmQueryGraph2,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._610name,
            keepAlive: true
          },

        },
        {
          path:'/RotatingMachineryGraph/OrbitOfShaftCenter1',
          name:'OrbitOfShaftCenter1',
          component: OrbitOfShaftCenter1,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._64name,
            keepAlive: true
          },

        },
        {
          path:'/RotatingMachineryGraph/RotatingComprehensiveAnalysis',
          name:'RotatingComprehensiveAnalysis',
          component: RotatingComprehensiveAnalysis,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._67name,
            keepAlive: true
          },
        },
        {
          path:'/RotatingMachineryGraph/SingleMultiBarValueChart',
          name:'RotatingSingleMultaBarGraph',
          component: RotatingSingleMultaBarGraph,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._63name,
            keepAlive: true
          },
        },
        {
          path:'/RotatingMachineryGraph/WholeSpectrumGraph',
          name:'WholeSpectrumGraph',
          component: WholeSpectrumGraph,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._611name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/RotatingVibrationMonitor',
          name: 'RotatingVibrationMonitor',
          component: RotatingVibrationMonitor,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._61name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/RotatingOverviewGrap',
          name: 'RotatingOverviewGrap',
          component: RotatingOverviewGrap,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._615name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/RotatingRunStatusGraph',
          name: 'RotatingRunStatusGraph',
          component: RotatingRunStatusGraph,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._68name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/OtherParametersTrendGraph2',
          name: 'OtherParametersTrendGraph2',
          component: OtherParametersTrendGraph2,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._69name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/VibrationHistoricalComparison',
          name: 'VibrationHistoricalComparison',
          component: VibrationHistoricalComparison,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._62name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/ThreeDimensionalHolography',
          name: 'ThreeDimensionalHolography',
          component: ThreeDimensionalHolography,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/RotatingMachineryGraph/TwoDimensionalHolography',
          name: 'TwoDimensionalHolography',
          component: TwoDimensionalHolography,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/RotatingMachineryGraph/AxisPosition',
          name: 'AxisPosition',
          component: AxisPosition,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._65name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/StartStopGraph',
          name: 'StartStopGraph',
          component: StartStopGraph,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._66name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/DynamicBalancing',
          name: 'DynamicBalancing',
          component: DynamicBalancing,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/RotatingMachineryGraph/ParameterComparisonQuery',
          name: 'ParameterComparisonQuery',
          component: ParameterComparisonQuery,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._616name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/ImpactDiagnosis',
          name: 'RotatingImpactDiagnosis',
          component: RotatingImpactDiagnosis,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._618name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/TemperatureiDstributionField',
          name: 'TemperatureiDstributionField',
          component: TemperatureiDstributionField,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._617name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/RotatingCepstrumGraph',
          name: 'RotatingCepstrumGraph',
          component: RotatingCepstrumGraph,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._619name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/RotatingHistoryTrendGraph',
          name: 'RotatingHistoryTrendGraph',
          component: RotatingHistoryTrendGraph,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._620name,
            keepAlive: true
          },
        },
        {
          path: '/RotatingMachineryGraph/RotatingSpectraWaterfall',
          name: 'RotatingSpectraWaterfall',
          component: RotatingSpectraWaterfall,
          meta: {
            title: config.menu.RotatingMachineryGraph.data._621name,
            keepAlive: true
          },
        },

        //以下是柴油机和往复机，增加跳转路径请在这个上面加
        //柴油机
        {
          path: '/DieselMonitorSystem/OverviewGraph',
          name: 'OverviewGraph',
          component: OverviewGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._51name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/DieselMonitorRunStatus',     //
          name: 'DieselMonitorRunStatus',
          component: DieselMonitorRunStatus,
          meta: {
            title: config.menu. DieselMonitorSystem.data._52name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/HistoricalComparisonGraph',
          name: 'HistoricalComparisonGraph',
          component: HistoricalComparisonGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._53name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/SingleValueStickGraph',
          name: 'OneBarGraph',
          component: OneBarGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._54name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/DynamicPressureMonitorGraph',
          name: 'DynamicPressureMonitorGraph',
          component: DynamicPressureMonitorGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._55name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/EventQueryGraph',
          name: 'EventQueryGraph',
          component: EventQueryGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._57name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/VibrationMonitorGraph',
          name: 'VibrationMonitorGraph',
          component: VibrationMonitorGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._58name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/InstantaneousSpeed',
          name: 'InstantaneousSpeed',
          component: InstantaneousSpeed,
          meta: {
            title: config.menu. DieselMonitorSystem.data._59name,
            keepAlive: false
          },
        },
        {
          path: '/DieselMonitorSystem/TorsionalVibration',
          name: 'TorsionalVibration',
          component: TorsionalVibration,
          meta: {
            title: config.menu. DieselMonitorSystem.data._511name,
            keepAlive: false
          },
        },
        {
          path: '/DieselMonitorSystem/MultiparameterAnalysis',
          name: 'MultiparameterAnalysis',
          component: MultiparameterAnalysis,
          meta: {
            title: config.menu. DieselMonitorSystem.data._512name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/ComprehensiveAnalysisGraph',
          name: 'ComprehensiveAnalysisGraph',
          component: ComprehensiveAnalysisGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._514name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/IndicatorGraph',
          name: 'IndicatorGraph',
          component: IndicatorGraph,
          meta: {
            title: config.menu. DieselMonitorSystem.data._516name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/ImpactDiagnosis',
          name: 'ImpactDiagnosis',
          component: ImpactDiagnosis,
          meta: {
            title: config.menu. DieselMonitorSystem.data._517name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/OtherParametersTrend',
          name: 'OtherParametersTrend',
          component: OtherParametersTrend,
          meta: {
            title: config.menu. DieselMonitorSystem.data._518name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/AlarmQuery',
          name: 'AlarmQuery',
          component: AlarmQuery,
          meta: {
            title: config.menu. DieselMonitorSystem.data._519name,
            keepAlive: true
          },
        },
        {
          path: '/DieselMonitorSystem/OnAndOffStateAnalysis',
          name: 'OnAndOffStateAnalysis',
          component: OnAndOffStateAnalysis,
          meta: {
            title: config.menu. DieselMonitorSystem.data._521name,
            keepAlive: false
          },
        },
        {
          path: '/DieselMonitorSystem/StartAndStopTimeQuery',
          name: 'StartAndStopTimeQuery',
          component: StartAndStopTimeQuery,
          meta: {
            title: config.menu. DieselMonitorSystem.data._522name,
            keepAlive: true
          },
        },
        //往复机
        {
          path: '/ReciprocatMachineryGraph/OverviewGraph1',
          name: 'OverviewGraph1',
          component: OverviewGraph1,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._41name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/ReciprocatAlarmQuery',   //往复报警
          name: 'ReciprocatAlarmQuery',
          component: ReciprocatAlarmQuery,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._42name
          },
        },

        {
          path: '/ReciprocatMachineryGraph/PistonRodSettlement',   //
          name: 'PistonRodSettlement',
          component: PistonRodSettlement,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._45name
          },
        },

        {
          path: '/ReciprocatMachineryGraph/RunStatusGraph1',
          name: 'RunStatusGraph1',
          component: RunStatusGraph1,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._48name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/HistoricalComparisonGraph1',
          name: 'HistoricalComparisonGraph1',
          component: HistoricalComparisonGraph1,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._44name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/SingleValueStickGraph1',
          name: 'OneBarGraph1',
          component: OneBarGraph1,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._411name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/ReciprocatVibrationMonitor',
          name: 'ReciprocatVibrationMonitor',
          component: ReciprocatVibrationMonitor,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._43name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/MultiparameterAnalysis1',
          name: 'MultiparameterAnalysis1',
          component: MultiparameterAnalysis1,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._49name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/ReciprocatComprehensiveAnalysis',
          name: 'ReciprocatComprehensiveAnalysis',
          component: ReciprocatComprehensiveAnalysis,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._412name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/OtherParametersTrend1',
          name: 'OtherParametersTrend1',
          component: OtherParametersTrend1,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._410name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/PistonRodTrackGraph',
          name: 'PistonRodTrackGraph',
          component: PistonRodTrackGraph,
          meta: {
            keepAlive: false,
            title: config.menu.ReciprocatMachineryGraph.data._413name
          },
        },

        {
          path: '/ReciprocatMachineryGraph/IndicatorGraph1',
          name: 'IndicatorGraph1',
          component: IndicatorGraph1,
          meta: {
            keepAlive: true,
            title: config.menu.ReciprocatMachineryGraph.data._46name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/ReciprocatImpactDiagnosis',
          name: 'ReciprocatImpactDiagnosis',
          component: ReciprocatImpactDiagnosis,
          meta: {
            title: config.menu.ReciprocatMachineryGraph.data._414name,
            keepAlive: true
          },
        },
        {
          path: '/ReciprocatMachineryGraph/StressMonitoring',
          name: 'StressMonitoring',
          component: StressMonitoring,
          meta: {
            keepAlive: true,
            // keepAlive: false,
            title: config.menu.ReciprocatMachineryGraph.data._47name
          },
        },
        {
          path: '/ReciprocatMachineryGraph/ReciprocatSpectraWaterfall',
          name: 'ReciprocatSpectraWaterfall',
          component: ReciprocatSpectraWaterfall,
          meta: {
            title: config.menu.ReciprocatMachineryGraph.data._415name,
            keepAlive: true
          },
        },

        // 离线
        {
          path: '/Offline/OLUnitOverviewMap',
          name: 'OLUnitOverviewMap',
          component: OLUnitOverviewMap,
          meta: {
            keepAlive: true
          },
        },
        {
          path: '/Offline/OLVibrationTrend',
          name: 'OLVibrationTrend',
          component: OLVibrationTrend,
          meta: {
            keepAlive: true
          },
        },
        {
          path: '/Offline/OLEnvelopeAnalysis',
          name: 'OLEnvelopeAnalysis',
          component: OLEnvelopeAnalysis,
          meta: {
            keepAlive: true
          },
        },
        {
          path: '/Offline/OLRetardedVariablesTrend',
          name: 'OLRetardedVariablesTrend',
          component: OLRetardedVariablesTrend,
          meta: {
            keepAlive: true
          },
        },
        {
          path: '/Offline/OLAlarmQueryAnalysis',
          name: 'OLAlarmQueryAnalysis',
          component: OLAlarmQueryAnalysis,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/Offline/OLComparativeAnalysis',
          name: 'OLComparativeAnalysis',
          component: OLComparativeAnalysis,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/Offline/OLComparisonAnalysis',
          name: 'OLComparisonAnalysis',
          component: OLComparisonAnalysis,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/Offline/OLOrbitOfShaftCenter',
          name: 'OLOrbitOfShaftCenter',
          component: OLOrbitOfShaftCenter,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/Offline/OLManualEntry',
          name: 'OLManualEntry',
          component: OLManualEntry,
          meta: {
            keepAlive: false
          },
        },
        {
          path: '/Offline/OLWallThicknessTrend',
          name: 'OLWallThicknessTrend',
          component: OLWallThicknessTrend,
          meta: {
            keepAlive: false
          },
        },
        // 离线结束

        // 无线机泵
        {
          path: '/WirelessPumpGraph/WirelessPumpUnitOverviewMap',
          name: 'WirelessPumpUnitOverviewMap',
          component: WirelessPumpUnitOverviewMap,
          meta: {
            keepAlive: true,
            title: config.menu.SpecialManualOfPump1.data._wu1name
          },

        },
        {
          path:'/WirelessPumpGraph/WirelessPumpImpactDiagnosis',
          name:'WirelessPumpImpactDiagnosis',
          component:WirelessPumpImpactDiagnosis,
          meta: {
            keepAlive: true,
            title: config.menu.SpecialManualOfPump1.data._wu4name
          },
        },
        {
          path: '/WirelessPumpGraph/WirelessPumpAlarmQueryGraph',
          name: 'WirelessPumpAlarmQueryGraph',
          component: WirelessPumpAlarmQueryGraph,
          meta: {
            keepAlive: true,
            title: config.menu.SpecialManualOfPump1.data._wu2name
          },

        },
        {
          path: '/WirelessPumpGraph/WirelessPumpOtherParametersTrendGraph',
          name: 'WirelessPumpOtherParametersTrendGraph',
          component: WirelessPumpOtherParametersTrendGraph,
          meta: {
            keepAlive: true,
            title: config.menu.SpecialManualOfPump1.data._wu8name
          },
        },
        {
          path: '/WirelessPumpGraph/WirelessPumpTrendAnalysis',
          name: 'WirelessPumpTrendAnalysis',
          component: WirelessPumpTrendAnalysis,
          meta: {
            keepAlive: true,
            title: config.menu.SpecialManualOfPump1.data._wu3name
          },
        },
        {
          path: '/WirelessPumpGraph/WaveformSpectraComparativeAnalysis',
          name: 'WirelessWaveformSpectraComparativeAnalysis',
          component: WirelessWaveformSpectraComparativeAnalysis,
          meta: {
            keepAlive: true,
            title: config.menu.SpecialManualOfPump1.data._wu9name,
          }
        },
        {
          path: '/WirelessPumpGraph/WirelessPumpEdgeComputingGraph',
          name: 'WirelessPumpEdgeComputingGraph',
          component: WirelessPumpEdgeComputingGraph,
          meta: {
            keepAlive: true,
            // title: config.menu.SpecialManualOfPump1.data._wu9name,
          }
        },
        {
          path: '/WirelessPumpGraph/WirelessPumpCepstrumGraph',
          name: 'WirelessPumpCepstrumGraph',
          component: WirelessPumpCepstrumGraph,
          meta: {
            keepAlive: true,
            // title: config.menu.SpecialManualOfPump1.data._wu9name,
          }
        },
        {
          path: '/WirelessPumpGraph/WirelessPumpSpectraWaterfall',
          name: 'WirelessPumpSpectraWaterfall',
          component: WirelessPumpSpectraWaterfall,
          meta: {
            keepAlive: true,
          }
        },

        // 无线ToC
        {
          path: '/WirelessToCMachineryGraph/ToCVibrationMonitor',
          name: 'ToCVibrationMonitor',
          component: ToCVibrationMonitor,
          meta: {
            keepAlive: true,
            title: config.menu.WirelessToCMachineryGraph.data._wu1name
          },

        },
        {
          path:'/WirelessToCMachineryGraph/ToCAlarmQueryGraph',
          name:'ToCAlarmQueryGraph',
          component:ToCAlarmQueryGraph,
          meta: {
            keepAlive: true,
            title: config.menu.WirelessToCMachineryGraph.data._wu2name
          },
        },

        //燃气轮机
        {
          path:'/gasTurbineGraph/AlarmQueryGraph2',
          name:'GasAlarmQueryGraph2',
          component: GasAlarmQueryGraph2,
          meta: {
            title: config.menu.gasTurbineGraph.data._610name,
            keepAlive: true
          },

        },
        {
          path:'/gasTurbineGraph/OrbitOfShaftCenter1',
          name:'GasOrbitOfShaftCenter1',
          component: GasOrbitOfShaftCenter1,
          meta: {
            title: config.menu.gasTurbineGraph.data._64name,
            keepAlive: true
          },

        },
        {
          path:'/gasTurbineGraph/GasComprehensiveAnalysis',
          name:'GasComprehensiveAnalysis',
          component: GasComprehensiveAnalysis,
          meta: {
            title: config.menu.gasTurbineGraph.data._67name,
            keepAlive: true
          },
        },
        {
          path:'/gasTurbineGraph/GasSingleMultaBarGraph',
          name:'GasSingleMultaBarGraph',
          component: GasSingleMultaBarGraph,
          meta: {
            title: config.menu.gasTurbineGraph.data._63name,
            keepAlive: true
          },
        },
        {
          path:'/gasTurbineGraph/WholeSpectrumGraph',
          name:'GasWholeSpectrumGraph',
          component: GasWholeSpectrumGraph,
          meta: {
            title: config.menu.gasTurbineGraph.data._611name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/GasVibrationMonitor',
          name: 'GasVibrationMonitor',
          component: GasVibrationMonitor,
          meta: {
            title: config.menu.gasTurbineGraph.data._61name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/GasOverviewGrap',
          name: 'GasOverviewGrap',
          component: GasOverviewGrap,
          meta: {
            title: config.menu.gasTurbineGraph.data._615name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/GasRunStatusGraph',
          name: 'GasRunStatusGraph',
          component: GasRunStatusGraph,
          meta: {
            title: config.menu.gasTurbineGraph.data._68name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/OtherParametersTrendGraph2',
          name: 'GasOtherParametersTrendGraph2',
          component: GasOtherParametersTrendGraph2,
          meta: {
            title: config.menu.gasTurbineGraph.data._69name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/VibrationHistoricalComparison',
          name: 'GasVibrationHistoricalComparison',
          component: GasVibrationHistoricalComparison,
          meta: {
            title: config.menu.gasTurbineGraph.data._617name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/ThreeDimensionalHolography',
          name: 'GasThreeDimensionalHolography',
          component: GasThreeDimensionalHolography,
          meta: {
            title: config.menu.gasTurbineGraph.data._613name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/TwoDimensionalHolography',
          name: 'GasTwoDimensionalHolography',
          component: GasTwoDimensionalHolography,
          meta: {
            title: config.menu.gasTurbineGraph.data._612name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/AxisPosition',
          name: 'GasAxisPosition',
          component: GasAxisPosition,
          meta: {
            title: config.menu.gasTurbineGraph.data._65name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/StartStopGraph',
          name: 'GasStartStopGraph',
          component: GasStartStopGraph,
          meta: {
            title: config.menu.gasTurbineGraph.data._66name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/DynamicBalancing',
          name: 'GasDynamicBalancing',
          component: GasDynamicBalancing,
          meta: {
            title: config.menu.gasTurbineGraph.data._614name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/TemperatureiDstributionField1',
          name: 'TemperatureiDstributionField1',
          component: TemperatureiDstributionField1,
          meta: {
            title: config.menu.gasTurbineGraph.data._616name,
            keepAlive: true
          },
        },
        {
          path: '/gasTurbineGraph/ParameterComparisonQuery',
          name: 'ParameterComparisonQuery',
          component: ParameterComparisonQuery,
          meta: {
            title: config.menu.gasTurbineGraph.data._617name,
            keepAlive: true
          },
        },
        //注意在柴油机和往复机上面加跳转路径，请看上一条注释
      ]
    },{
      path: '/home',
      component: menu,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js